<template>
    <div>
        <Transfer v-if="token" :token="token" />
        <ClickAndBuy v-if="clickandbuy" :click-and-buy-i-d="clickandbuy" />
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import Transfer from '@/views/Transfer.vue';
import ClickAndBuy from '@/views/clickandbuy/ClickAndBuy.vue';

const navigatorLanguages = [
    {
        key: 'de',
        codes: ['de', 'de-*'],
    },
    {
        key: 'ch',
        codes: ['ch', 'ch-*'],
    },
    {
        key: 'at',
        codes: ['at', 'at-*'],
    },
    {
        key: 'li',
        codes: ['li', 'li-*'],
    },
    {
        key: 'en',
        codes: ['en', 'en-*'],
    },
    {
        key: 'it',
        codes: ['it', 'it-*'],
    },
    {
        key: 'fr',
        codes: ['fr', 'fr-*'],
    },
    {
        key: 'nl',
        codes: ['nl', 'nl-*'],
    },
    {
        key: 'fi',
        codes: ['fi', 'fi-*'],
    },
];

const allowedLanguages = ['de', 'ch', 'at', 'li', 'en', 'it', 'fr', 'nl', 'fi'];

export default {
    name: 'Lang',
    components: {ClickAndBuy, Transfer},
    data() {
        return {
            token: null,
            clickandbuy: null,
        };
    },
    created() {
        this.getNode();
    },
    methods: {
        getNode() {
            let http = axios.create();
            http.get(this.apiUrl + '/mode')
                .then((response) => {
                    const mode = response.data.mode;

                    this.$store.state.mode = mode;
                    this.error = null;
                    this.loading = false;

                    if (mode === 'swifter') {
                        const parts = this.$route.path.split('/');
                        this.token = parts[2];

                        if (parts[2] === '' || parts[2] === undefined) {
                            this.process();
                        }
                    } else if (mode === 'clickandbuy') {
                        const parts = this.$route.path.split('/');
                        this.clickandbuy = parts[2];

                        if (parts[2] === '' || parts[2] === undefined) {
                            this.process();
                        }
                    } else {
                        this.process();
                    }
                })
                .catch((e) => {
                    this.checkGenericError(e);
                    this.error = e;
                    this.loading = false;
                });
        },
        process() {
            let lang = Vue.localStorage.get('language');

            if (!allowedLanguages.includes(lang)) {
                for (let i = 0, j = navigatorLanguages.length; i < j; i++) {
                    let navigatorLanguage = navigator.language;
                    navigatorLanguage = navigatorLanguage.toLowerCase();

                    let wildcard = navigatorLanguage.substring(0, 3) + '*';

                    if (
                        navigatorLanguages[i].codes.includes(
                            navigatorLanguage
                        ) ||
                        navigatorLanguages[i].codes.includes(wildcard)
                    ) {
                        lang = navigatorLanguages[i].key;
                        break;
                    }
                }

                if (!lang) {
                    lang = 'de';
                }
            }

            this.$i18n.locale = lang;
            Vue.localStorage.set('language', lang);

            const startLocation = this.$router.history._startLocation;
            const hasLangPrefix = allowedLanguages.some(
                (lang) =>
                    startLocation.startsWith(`/${lang}/`) ||
                    startLocation === `/${lang}`
            );

            if (!hasLangPrefix && startLocation !== '/') {
                this.$router.push(`/${lang}${startLocation}`);
                return;
            }

            this.$router.push('/' + lang);
        },
    },
};
</script>

<style lang="scss" scoped></style>
